
const config = {
  socketUrl: process.env.REACT_APP_SOCKET_SERVER_URL || '',
  guestPaymentMode: process.env.REACT_APP_GUEST_PAYMENT_METHOD || '',
  branding: process.env.REACT_APP_BRANDING || 'energic', // Base fallback brand preset
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  hyperPayScriptUrl:
    process.env.REACT_APP_HYPER_PAY_SCRIPT_URL || 'https://eu-test.oppwa.com/v1/paymentWidgets.js',
  // hyperPayScriptUrlProd:
  //   process.env.REACT_APP_HYPER_PAY_SCRIPT_URL_PROD ||
  //   'https://eu-prod.oppwa.com/v1/paymentWidgets.js',
  accountApiUrl: `${process.env.REACT_APP_API_URL}account/`,
  authApiUrl: `${process.env.REACT_APP_API_URL}auth/`,
  commonApiUrl: `${process.env.REACT_APP_API_URL}common/`,
  ocppApiUrl: `${process.env.REACT_APP_API_URL}ocpp-service/`,
  reportApiUrl: `${process.env.REACT_APP_API_URL}reporting/`,
  notificationApiUrl: `${process.env.REACT_APP_API_URL}notification/`,
  transactionApiUrl: `${process.env.REACT_APP_API_URL}transactions/`,
  emspApiUrl: `${process.env.REACT_APP_API_URL}emsp/`,

  // Mobile app deep link url
  deepLink: process.env.REACT_APP_DEEP_LINK || 'energic://evse',
  domain: process.env.REACT_APP_DOMAIN,
  appUrl: process.env.REACT_APP_URL,
};

export default config;
